import { createSelector } from "@reduxjs/toolkit";

export const documentsListState = (state) => state.documentsList;

export const documentListSelectors = createSelector(documentsListState, (state) => state);
